// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React from "react"
import * as styles from "./styles.module.scss"

interface Props {
  name: string
  message: string
  hidden?: boolean
  className?: string
  isSender?: boolean
}

const SpeechBubble: React.FC<Props> = ({
  message,
  isSender,
  hidden,
  className,
}) => {
  return (
    <div
      className={`${styles.bubble} ${
        isSender ? styles.sender : styles.receiver
      } ${hidden ? "hidden" : "flex"} ${className}`}
    >
      <p className={styles.messageBody}>{message}</p>
    </div>
  )
}

SpeechBubble.defaultProps = {
  className: "",
  isSender: false,
  hidden: false,
}

export default SpeechBubble
